// Service catalog — drives /services hub, homepage strip, quote form select,
// and the dedicated service pages. Brakes have their own pillar page.
export const SERVICE_NAV = [
  { slug: "/brake-replacement", label: "Brake Replacement", value: "brakes", featured: true },
  { slug: "/wheel-bearing-hub-replacement", label: "Wheel Bearings", value: "wheel-bearing" },
  { slug: "/suspension-repair", label: "Suspension", value: "suspension" },
  { slug: "/alternator-replacement", label: "Alternators", value: "alternator" },
  { slug: "/starter-replacement", label: "Starters", value: "starter" },
  { slug: "/tune-ups-maintenance", label: "Tune-Ups", value: "tune-up" },
];

export const WARRANTY_NOTE =
  "Covered by our 3-year / 36,000-mile parts-and-labor warranty when My Mobile Mechanic supplies the parts.";

export const SERVICE_PAGES = [
  {
    slug: "wheel-bearing-hub-replacement",
    value: "wheel-bearing",
    name: "Wheel Bearing & Hub Replacement",
    metaTitle: "Mobile Wheel Bearing & Hub Replacement | Middlesex MA & Southern NH",
    metaDesc:
      "Humming or growling that gets louder with speed? Mobile wheel bearing and hub assembly replacement at your home or workplace. 3-yr/36k-mile warranty. Get a quote.",
    h1: "Wheel Bearing & Hub Replacement, Wherever You're Parked",
    intro:
      "A failing wheel bearing usually starts as a low hum or growl that gets louder with speed — and it never fixes itself. Left alone, it can damage the hub, the axle and eventually the wheel itself. With 20+ years of hands-on repair experience, Manny replaces wheel bearings and complete hub assemblies at your home or workplace across Middlesex County, MA and Southern New Hampshire.",
    signsTitle: "Signs of a Bad Wheel Bearing",
    signs: [
      "Humming or growling that gets louder with speed",
      "Noise that changes when you turn left or right",
      "Steering wheel vibration at highway speed",
      "Uneven or cupped tire wear",
      "ABS or traction control warning light",
      "Loose feeling or play in the wheel",
    ],
    sections: [
      {
        h2: "Bearing or Complete Hub Assembly?",
        text: "Many modern vehicles use a sealed hub assembly instead of a press-in bearing — it's faster to replace and often more reliable. We confirm exactly what your year, make and model uses before quoting, so there are no surprises on the day of the job.",
      },
      {
        h2: "Diagnosed First, Not Guessed",
        text: "Road noise can come from tires, bearings or brakes — and they sound similar. Every wheel bearing job starts with a road test and a lift check to confirm which corner is actually failing. You only pay to fix what's actually broken.",
      },
    ],
    warranty: true,
  },
  {
    slug: "suspension-repair",
    value: "suspension",
    name: "Suspension Repair",
    metaTitle: "Mobile Suspension Repair | Struts, Ball Joints & Control Arms — We Come to You",
    metaDesc:
      "Clunks, bouncing or uneven tire wear? Mobile suspension repair — struts, shocks, ball joints, control arms — at your home or workplace in Middlesex MA & Southern NH.",
    h1: "Mobile Suspension Repair for New England Roads",
    intro:
      "Massachusetts potholes and New Hampshire frost heaves are brutal on suspension. If your car clunks over bumps, bounces down the highway or wanders in its lane, Manny brings the repair to you — struts, shocks, control arms, ball joints and sway bar links replaced at your home or workplace.",
    signsTitle: "Signs Your Suspension Needs Attention",
    signs: [
      "Clunking or knocking over bumps",
      "Excessive bouncing after dips",
      "Nose-dives when braking",
      "Uneven or rapid tire wear",
      "Loose, wandering steering",
      "One corner of the car sits lower",
    ],
    sections: [
      {
        h2: "What We Service",
        text: "Struts and shocks, control arms, ball joints, sway bar links and tie rod ends — the parts that wear out first on New England roads. Worn suspension doesn't just ride badly: it lengthens your braking distance and eats tires. We inspect the whole corner, not just the noisy part, so a new strut doesn't hide a worn ball joint.",
      },
      {
        h2: "Straight Answers, On Site",
        text: "Suspension diagnosis is hands-on: we lift the vehicle, check for play, and show you exactly what's worn before any work begins. If a part still has life in it, we'll tell you — that's how a 2-million-follower repair channel is built.",
      },
    ],
    warranty: true,
  },
  {
    slug: "alternator-replacement",
    value: "alternator",
    name: "Alternator Replacement",
    metaTitle: "Mobile Alternator Replacement | Middlesex County MA & Southern NH",
    metaDesc:
      "Battery light on or car keeps dying? We test your charging system and replace the alternator at your home or workplace. Warranty-backed. Get a quote today.",
    h1: "Alternator Replaced Where Your Car Sits",
    intro:
      "When an alternator fails, your car runs off the battery until it dies — usually at the worst possible time. The good news: you don't need a tow. We come to your driveway or workplace, test the charging system, and replace the alternator on the spot anywhere in Middlesex County, MA or Southern NH.",
    signsTitle: "Signs of a Failing Alternator",
    signs: [
      "Battery warning light on the dash",
      "Headlights dimming or flickering",
      "A new battery that keeps dying",
      "Slow windows, weak blower, electrical glitches",
      "Whining or grinding from the engine bay",
      "Car stalls or won't restart after driving",
    ],
    sections: [
      {
        h2: "Tested First — Not Guessed",
        text: "A dead car isn't always the alternator. Batteries, cables and corroded terminals cause the same symptoms, so every job starts with a proper charging-system test. If your alternator is fine and you just need a battery or a cable, that's all you'll pay for.",
      },
      {
        h2: "No Tow Truck Required",
        text: "A car with a dead alternator usually can't drive anywhere — which is exactly why mobile replacement makes sense. We bring the correct remanufactured or new unit for your vehicle and have you back on the road the same visit in most cases.",
      },
    ],
    warranty: true,
  },
  {
    slug: "starter-replacement",
    value: "starter",
    name: "Starter Replacement",
    metaTitle: "Mobile Starter Replacement | We Come to You — Middlesex MA & Southern NH",
    metaDesc:
      "Car clicks but won't start? Mobile starter testing and replacement at your home or workplace across Middlesex County, MA & Southern NH. Get a quote.",
    h1: "Car Won't Crank? We Bring the Starter to You",
    intro:
      "Few sounds are worse than turning the key and getting one lonely click. A failed starter strands you wherever the car sits — which makes it the perfect mobile repair. Manny comes to you, confirms the starter is actually the problem, and replaces it on site.",
    signsTitle: "Signs of a Bad Starter",
    signs: [
      "Single click or rapid clicking when you turn the key",
      "Engine won't crank but lights and radio work",
      "Intermittent no-start — fine one day, dead the next",
      "Grinding noise when starting",
      "Starts only after several tries",
    ],
    sections: [
      {
        h2: "Starter, Battery or Wiring?",
        text: "All three cause a no-crank, and guessing wrong costs real money. Before anything is replaced, we test battery health, voltage drop and the starter circuit itself. If it's a loose cable or a weak battery, you'll know — and you'll only pay for that.",
      },
      {
        h2: "Stranded at Home? That's the Point",
        text: "Most starter failures happen in driveways and parking lots, not at shops. Mobile replacement means no tow bill and no waiting room — the repair happens where the car already sits.",
      },
    ],
    warranty: true,
  },
  {
    slug: "tune-ups-maintenance",
    value: "tune-up",
    name: "Tune-Ups & Maintenance",
    metaTitle: "Mobile Tune-Ups & Maintenance | Middlesex County MA & Southern NH",
    metaDesc:
      "Spark plugs, filters, belts, fluids and scheduled maintenance done at your home or workplace. 20+ years of experience, warranty-backed work. Get a quote.",
    h1: "Tune-Ups & Maintenance Without the Shop Visit",
    intro:
      "Staying ahead of maintenance is cheaper than fixing what breaks — but nobody wants to spend a Saturday at a shop. Manny brings scheduled maintenance to your driveway: spark plugs, filters, belts and hoses, fluids and batteries, all done where your car is parked.",
    signsTitle: "What We Can Handle On Site",
    signs: [
      "Spark plugs & ignition coils",
      "Engine and cabin air filters",
      "Serpentine belts & hoses",
      "Battery testing & replacement",
      "Fluid checks & top-offs",
      "Pre-purchase & seasonal inspections",
    ],
    sections: [
      {
        h2: "Maintenance That Prevents Breakdowns",
        text: "A $30 belt is an easy driveway job today — or a tow and an overheated engine next month. With 20+ years of repair experience, we know what fails, when it fails, and what's worth doing early on your specific vehicle.",
      },
      {
        h2: "Honest Schedules, Not Upsells",
        text: "We follow your owner's manual, not a shop's sales board. You'll get a straight answer on what's due, what can wait, and what your car doesn't need at all.",
      },
    ],
    warranty: true,
  },
];

export const serviceBySlug = (slug) => SERVICE_PAGES.find((s) => s.slug === slug);
